<template>
  <b-row>
    <b-col
      v-for="(attachment, index) in attachments"
      :key="index"
      xl="4"
      lg="6"
      md="6"
      class="mb-4"
    >
      <b-row class="request-thumbnail mx-1">
        <b-col
          lg="4"
          xl="4"
          sm="3"
          class="p-2"
        >
          <img
            :src="getThumbnailImage(attachment)"
            alt="attachment-image"
            class="img-fluid"
            style="cursor: pointer;"
            aria-hidden="true"
          >
        </b-col>
        <b-col
          lg="8"
          xl="8"
          sm="9"
          class="pl-1 thumb-text mb-1 p-1"
        >
          <div class="mt-1">
            <a
              type="button"
              class="linkbtn"
              target="_blank"
            ><h6 class="photo-text-truncated">{{ attachment.filename }}</h6>
            </a>
          </div>
          <div class="mt-1 thumb-author">
            {{ attachment.createdBy.fullName }}
          </div>
          <div class="thumb-date mt-2">
            {{ attachment.creationDate | datetime }}
          </div>
          <div class="thumb-size">
            {{ fileSize(attachment) }}
          </div>
        </b-col>
        <div class="download-icon">
          <b-button
            v-tooltip="$t('global.download')"
            class="btn__icon btn__icon--primary mx-2 p-0"
            @click="download(attachment.attachmentId, index)"
          >
            <i
              class="fal fa-arrow-to-bottom"
              aria-hidden="true"
            />
          </b-button>
          <b-button
            class="btn__icon btn__icon--primary mx-2 p-0"
            @click="deleteAttachmentConfirmation(attachment)"
          >
            <i
              v-tooltip="$t('global.delete')"
              class="fal fa-trash-alt"
              aria-hidden="true"
            />
          </b-button>
        </div>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>

import { saveAs } from 'file-saver'
import patientAttachmentService from '@/api/resources/attachment/patientAttachmentService'

export default {
    name: 'RequestDownloadableAttachment',
    props: {
        attachments: { type: Array, required: true },
        patientId: { type: Number, required: true }
    },
    methods: {
        fileSize(attachment) {
            if (attachment.length < 1024) {
                return attachment.length + ' Bytes'
            } else if (attachment.length < 1048576) {
                return Math.round(attachment.length / 1024) + ' KB'
            } else {
                return Math.round(attachment.length / 1048576) + ' MB'
            }
        },
        async download(attachmentId, index) {
            if (attachmentId) {
                const [err, blob] = await this.toCall(patientAttachmentService.getFile(
                    this.patientId, attachmentId))
                if (err) {
                    this.showErrorModalGlobal()
                    return
                }
                // eslint-disable-next-line no-undef
                saveAs(blob, this.attachments[index].fileName)
            }
        },
        async deleteAttachmentConfirmation(attachment) {
            const deleteConfirmation = await this.showConfirmationModalGlobal()
            if (deleteConfirmation) {
                this.deleteAttachment(attachment)
            }
        },
        async deleteAttachment(attachment) {
            const [err] = await this.toCall(patientAttachmentService.deleteAttachment(this.patientId, attachment.attachmentId))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.$emit('deleteAttachment', attachment.attachmentId)
        },
        getThumbnailImage(attachment) {
            if (!attachment.thumbnailBytes) {
                return null
            } else if (attachment.thumbnailBytes.startsWith('data:')) {
                return attachment.thumbnailBytes
            } else {
                return `data:${attachment.mimetype};base64, ${attachment.thumbnailBytes}`
            }
        }
    }
}

</script>

<style lang="scss" scoped>

    .request-thumbnail {
        border: 1px solid vt-color(general-border);
        border-radius: 5px;
        position: relative;
        box-shadow: 0px 1px 3px 0px #9c9c9c;
    }

    .request-thumbnail:hover {
        box-shadow: 0px 2px 5px 0px #9c9c9c;
    }

    .img-poster {
        position: relative;
        height: 130px;
    }

    .img-poster img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .thumb-size {
        margin-top: 10px;
        font-size: font-size(small);
    }

    .thumb-header {
        border: 1px solid #d8d8d8;
    }

    .thumb-content {
        max-height: 180px;
        overflow: hidden;
        overflow-y: auto;
        padding-right: 10px;
        padding-bottom: 20px;
    }

    .thumb-img{
        max-height: 55px;
    }

    .photo-text-truncated{
        width: calc(100% - 20px) !important;
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        line-height: 14px !important;
        margin: 0 !important;
    }

    .request-thumbnail h6 {
        font-size: font-size(very-small) !important;
        color: vt-color(primary);
        line-height: .5;
        margin-top: 10px;
    }

    .thumb-author {
        font-size: .9rem;
    }

    .thumb-date {
        font-size: font-size(small) !important;
    }

    .thumb-text {
        line-height: 14px;
    }

    .download-icon {
        position: absolute;
        right: 5px;
        bottom: 1px;
    }

    @media (max-width: 1370px) {

        .request-thumbnail h6 {
            font-size: .85rem;
            color: vt-color(primary);
            line-height: .5;
            margin-top: 8px;
        }

        .thumb-author {
            font-size: .7rem;
        }

        .thumb-date {
            font-size: .7rem;
        }

        .thumb-text {
            line-height: 9px;
        }

    }

    @media (min-width: 1400px) {

        .linkbtn h6 {
            width: 140px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 0 !important;
        }

        .request-thumbnail h6 {
            font-size: .9rem;
            color: vt-color(primary);
            line-height: 23px !important;
            margin-top: 8px;
        }

        .thumb-author {
            font-size: .7rem;
        }

        .thumb-date {
            font-size: .7rem;
        }

        .thumb-text {
            line-height: 9px;
        }

    }

</style>
